import styled from "styled-components";

import FormSelect from "./";

export const CustomFormSelect = styled(FormSelect)`
  border-top: 0;
  border-right: 0;
  border-left: 0;
`;
